'use client';

import {
  Icon,
  IconArrowBackUp,
  IconArrowRight,
  IconArticle,
  IconBan,
  IconBrandTelegram,
  IconCalendarEvent,
  IconCalendarOff,
  IconCalendarTime,
  IconCheck,
  IconEdit,
  IconEye,
  IconFileDislike,
  IconFileImport,
  IconFileInvoice,
  IconFileUpload,
  IconFlag,
  IconLicense,
  IconMessage2,
  IconMessage2Question,
  IconPencilPlus,
  IconPlus,
  IconReportMoney,
  IconThumbDown,
  IconThumbUp,
  IconTournament,
  IconTransfer,
  IconTrophy,
  IconUserMinus,
  IconUserPlus,
  IconWriting,
  IconFilePlus,
  IconFileX,
  IconFileLike,
  IconFileOff,
  IconReport,
  IconX,
  IconAlertCircle,
  IconQuestionMark,
  IconBell,
  IconSend,
  IconLock,
  IconLockOpen,
  IconCamera,
  IconScale,
  IconPaperclip,
  IconTag,
  IconFile,
} from '@tabler/icons-react';
import {
  AuthInfoResponseBody,
  EventComplete,
  EventDetailUnion,
  formatClaimEstimateValue,
} from 'bff';
import { EventDetailObjects, EventType, User, UserType } from 'database';
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage, Badge, cn } from 'ui';
import { FileList, FileListItem, FileListLabel } from './File';
import { useTranslations } from 'i11n';
//@ts-ignore
import { format } from 'date-fns';
import { useSharedAuth } from '..';
import Link from 'next/link';
import { buildUserDisplayName, getInitialsFromUser } from 'utils';

//@ts-ignore
const iconsByEvents: {
  [K in EventType]: Icon;
} = {
  pending_file_request_upload: IconBell,
  complaint_rejected: IconThumbDown,
  complaint_approved: IconThumbUp,
  complaint_authorized: IconCheck,
  external_complaint_selected: IconCheck,
  claim_sinister_changed: IconTransfer,
  claim_updated: IconEdit,
  claim_estimates_updated: IconReportMoney,
  claim_ownership_assigned: IconTransfer,
  claim_ownership_transfer_rejected: IconBan,
  claim_ownership_transfer_accepted: IconCheck,
  claim_ownership_transfer_requested: IconBrandTelegram,
  contract_created: IconWriting,
  order_created: IconWriting,
  rfp_created: IconTournament,

  contract_invoice_uploaded: IconFileInvoice,
  contract_updates_requested: IconQuestionMark,
  contract_updates_published: IconArticle,

  claim_documentation_requested: IconQuestionMark,

  order_invoice_uploaded: IconFileInvoice,
  order_updates_requested: IconQuestionMark,
  order_updates_published: IconArticle,
  order_document_uploaded: IconFileUpload,
  order_document_removed: IconFileOff,

  contract_report_rejected: IconX,
  contract_report_created: IconReport,
  contract_report_accepted: IconCheck,

  order_report_rejected: IconX,
  order_report_created: IconReport,
  order_report_accepted: IconCheck,

  // F1.4.3 order lifecycle + F1.4.4 deliverable review.
  order_accepted: IconCheck,
  order_rejected: IconX,
  order_canceled: IconBan,
  order_completed: IconLicense,
  order_reopened: IconLockOpen,
  order_report_reset: IconArrowBackUp,
  order_invoice_accepted: IconFileLike,
  order_invoice_rejected: IconFileX,
  order_invoice_reset: IconArrowBackUp,

  // order_required_docs — required-document lifecycle.
  order_required_document_uploaded: IconFileUpload,
  order_required_document_accepted: IconFileLike,
  order_required_document_rejected: IconFileX,
  order_required_document_reset: IconArrowBackUp,

  // order_work_proof — prueba de trabajo Autoinspector.
  order_work_proof_created: IconCamera,
  order_work_proof_approved: IconCheck,
  order_work_proof_disapproved: IconThumbDown,
  order_work_proof_blocked: IconBan,

  // order_scheduling — when the work is planned.
  order_scheduled: IconCalendarEvent,
  order_rescheduled: IconCalendarEvent,
  order_schedule_canceled: IconCalendarOff,

  appraisal_invoice_uploaded: IconFileInvoice,
  appraisal_updates_requested: IconQuestionMark,
  appraisal_updates_published: IconArticle,
  appraisal_report_rejected: IconX,
  appraisal_report_created: IconReport,
  appraisal_report_accepted: IconCheck,

  external_complaint_created: IconPencilPlus,

  pending_complaint_created: IconPlus,
  pending_complaint_requested: IconPlus,
  pending_complaint_creation_failed: IconX,
  external_complaint_selection_failed: IconX,

  offer_expired: IconCalendarTime,
  offer_rejected: IconFileDislike,
  offer_accepted: IconFileLike,

  offer_agreement_expired: IconCalendarTime,
  offer_agreement_cancelled: IconFileDislike,
  offer_agreement_rejected: IconFileDislike,
  offer_agreement_completed: IconLicense,
  offer_agreement_created: IconSend,
  offer_agreement_dispatch_failed: IconAlertCircle,
  offer_agreement_recipient_submitted: IconLicense,

  sinister_complaint_chat_message_send: IconMessage2,
  sinister_claim_chat_message_send: IconMessage2,
  fraud_news_requested: IconMessage2Question,
  fraud_news_answered: IconArticle,
  fraud_updated: IconEdit,
  fraud_investigation_case_created: IconLicense,
  fraud_claim_result_updated: IconScale,
  fraud_closed: IconLock,
  fraud_reopened: IconLockOpen,
  claim_form_step_completed: IconFlag,
  claim_form_step_view: IconEye,

  claim_derived: IconArrowRight,
  claim_responsibility_returned: IconArrowBackUp,
  claim_derived_returned: IconArrowBackUp,
  claim_derivation_canceled: IconBan,
  claim_derivation_restore_status_updated: IconArrowBackUp,

  claim_responsible_unassigned: IconUserMinus,
  claim_responsible_assigned: IconUserPlus,

  claim_collaborator_unassigned: IconUserMinus,
  claim_collaborator_assigned: IconUserPlus,

  complaint_collaborator_unassigned: IconUserMinus,
  complaint_collaborator_assigned: IconUserPlus,

  claim_created: IconLicense,
  complaint_created: IconLicense,
  file_requested: IconFileImport,
  file_request_placeholder_cancelled: IconFileOff,
  file_request_uploaded: IconFileUpload,
  upload_files: IconFileUpload,
  claim_status_updated: IconFileUpload,
  claim_status_communication_sent: IconSend,
  complaint_status_updated: IconFileUpload,
  complaint_sinister_cause_updated: IconFileUpload,
  rfp_bid_submitted: IconSend,
  rfp_bid_winner_selected: IconTrophy,
  rfp_expired: IconX,

  alert_sla_objective_progress: IconAlertCircle,
  alert_sla_total_progress: IconAlertCircle,

  offer_created: IconFilePlus,
  offer_canceled: IconFileX,

  claim_created_documents_missing: IconFileX,
  sinister_external_status_updated: IconFileUpload,
};

interface ActivityContext {
  eventsCount: number;
  event: EventComplete;
  index: number;
}

const ActivityContext = React.createContext<ActivityContext | undefined>(
  undefined,
);

const useActivityContext = () => React.useContext(ActivityContext)!;

const EventDetailList = ({ children }: { children: React.ReactNode }) => {
  return <div className='gap-2 flex flex-row flex-wrap'>{children}</div>;
};

const MessageAuthor = ({
  children,
  icon = false,
}: {
  children: React.ReactNode;
  icon?: boolean;
}) => {
  return (
    <p className='text-muted-foreground text-xs flex items-center gap-1'>
      {icon && <IconMessage2 className='w-3.5 h-3.5' />}
      <span className='italic'>{children}</span>
    </p>
  );
};

const EventDetailContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'w-full mt-1 space-y-2 text-base_brand [overflow-wrap:anywhere]',
        className,
      )}
    >
      {children}
    </div>
  );
};

function isIsoDate(str: string) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
  const d = new Date(str);
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str; // valid date
}

const parseSuperType = (value: any, fallback: () => string) => {
  if (value && isIsoDate(value)) return format(new Date(value), 'dd/MM/yyyy');

  if (typeof value === 'boolean') return value ? 'Si' : 'No';

  return fallback();
};

const EventDetail = () => {
  const { event } = useActivityContext();

  const auth = useSharedAuth();

  const t = useTranslations('claim.steps');

  const fraudResults = useTranslations('fraud.results');

  const fraudClaimResults = useTranslations('fraud.claimResults');

  const fraudInternalStatus = useTranslations('fraud.internalStatus');

  const fraudStatus = useTranslations('fraud.status');

  const rootT = useTranslations();

  const isTriggeredByAuthUser = event.triggered_by?.id === auth.user?.id;
  const isInsurer = auth.user?.type === 'insurer';

  switch (event.type) {
    case 'claim_comment_created':
      return (
        <EventDetailContainer>
          <p className='italic text-base_brand min-h-7 flex flex-col justify-center whitespace-pre-wrap'>
            {event.metadata!.comment_content!}
          </p>
        </EventDetailContainer>
      );

    case 'alert_sla_objective_progress':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>SLA: {event.metadata.sla_name}</Badge>
            <Badge variant='outline'>
              {rootT(
                `sla.types.${event.metadata.sla_objective_reference_type}`,
              )}
              : {event.metadata.sla_objective_reference_name}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'alert_sla_total_progress':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>SLA: {event.metadata.sla_name}</Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'complaint_estimates_updated':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Cobertura: {event.metadata.affected_coverage_name}
            </Badge>
            {event.metadata.operands.map((operand, index) => (
              <Badge key={index} variant='outline'>
                {operand.name}: {operand.value}
              </Badge>
            ))}
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'external_complaint_rejected':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Denuncia: {event.metadata.external_complaint_id}
            </Badge>

            <p>Motivo: {event.metadata.reason}</p>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'external_complaint_approved':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Denuncia: {event.metadata.external_complaint_id}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'external_complaint_authorized':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Denuncia: {event.metadata.external_complaint_id}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'external_complaint_created':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Denuncia: {event.metadata.external_complaint_id}
            </Badge>

            <Badge variant='outline'>
              Póliza: {event.metadata.external_policy_number}
            </Badge>

            <Badge variant='outline'>
              Coberturas: {event.metadata.coverages.join(', ')}
            </Badge>
            <Badge variant='outline'>
              Causa del siniestro: {event.metadata.sinister_cause_name}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'rfp_expired':
      return (
        <EventDetailContainer>
          <Badge variant='outline'>{event.metadata.rfp_name}</Badge>
        </EventDetailContainer>
      );

    case 'contract_invoice_uploaded':
    case 'appraisal_invoice_uploaded':
      return (
        <EventDetailContainer>
          <Badge variant='outline'>
            {event.metadata.invoice_original_name}
          </Badge>
        </EventDetailContainer>
      );

    case 'order_updates_published':
    case 'order_updates_requested':
    case 'contract_updates_published':
    case 'contract_updates_requested':
    case 'appraisal_updates_published':
    case 'appraisal_updates_requested':
      return (
        <EventDetailContainer>
          <MessageAuthor icon>{event.metadata.message}</MessageAuthor>
        </EventDetailContainer>
      );

    // F2.4 — carga manual de documentación: se listan los archivos subidos.
    // order_document_import — el borrado lógico usa el mismo detalle.
    case 'order_document_uploaded':
    case 'order_document_removed':
      if (!event.metadata.file_names?.length) return null;
      return (
        <EventDetailContainer>
          <EventDetailList>
            {event.metadata.file_names.map((name, index) => (
              <Badge key={index} variant='outline' className='text-xs'>
                <IconPaperclip className='w-3 h-3 mr-1' />
                {name}
              </Badge>
            ))}
          </EventDetailList>
        </EventDetailContainer>
      );

    // order_required_docs — document name + version + file; rejects also show
    // the reason.
    case 'order_required_document_uploaded':
    case 'order_required_document_accepted':
    case 'order_required_document_rejected':
    case 'order_required_document_reset':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline' className='text-xs'>
              {event.metadata.document_name}
            </Badge>
            {event.metadata.version != null && (
              <Badge variant='outline' className='text-xs'>
                <IconTag className='w-3 h-3 mr-1' />
                Versión {event.metadata.version}
              </Badge>
            )}
            {event.metadata.file_original_name && (
              <Badge variant='outline' className='text-xs'>
                <IconPaperclip className='w-3 h-3 mr-1' />
                {event.metadata.file_original_name}
              </Badge>
            )}
          </EventDetailList>
          {event.type === 'order_required_document_rejected' &&
            event.metadata.reason && (
              <MessageAuthor icon>{event.metadata.reason}</MessageAuthor>
            )}
        </EventDetailContainer>
      );

    case 'contract_report_rejected':
    case 'contract_report_accepted':
    case 'contract_report_created':
    case 'appraisal_report_rejected':
    case 'appraisal_report_accepted':
    case 'appraisal_report_created':
      return (
        <EventDetailContainer>
          {event.type === 'appraisal_report_rejected' && (
            <MessageAuthor>{event.metadata.reason}</MessageAuthor>
          )}
          <EventDetailList>
            <Badge variant='outline'>Versión {event.metadata.version}</Badge>
            {'report_original_name' in event.metadata && (
              <Badge variant='outline'>
                Informe {event.metadata.report_original_name}
              </Badge>
            )}
          </EventDetailList>
        </EventDetailContainer>
      );

    // F1.4.4 — every order deliverable event (report/invoice: upload, accept,
    // reject, reset) surfaces its version; rejects also show the reason. Version
    // is rendered when present (older events predate the field).
    case 'order_report_created':
    case 'order_report_accepted':
    case 'order_report_rejected':
    case 'order_report_reset':
    case 'order_invoice_uploaded':
    case 'order_invoice_accepted':
    case 'order_invoice_rejected':
    case 'order_invoice_reset':
      return (
        <EventDetailContainer>
          <EventDetailList>
            {event.metadata.version != null && (
              <Badge variant='outline' className='text-xs'>
                <IconTag className='w-3 h-3 mr-1' />
                Versión {event.metadata.version}
              </Badge>
            )}
            {event.metadata.file_original_name && (
              <Badge variant='outline' className='text-xs'>
                <IconPaperclip className='w-3 h-3 mr-1' />
                {event.metadata.file_original_name}
              </Badge>
            )}
          </EventDetailList>
          {(event.type === 'order_invoice_rejected' ||
            event.type === 'order_report_rejected') &&
            event.metadata.reason && (
              <MessageAuthor icon>{event.metadata.reason}</MessageAuthor>
            )}
        </EventDetailContainer>
      );

    // F1.4.3 — order reject / cancel carry the reason (mirrors invoice reject).
    // order_scheduling — voiding the coordination carries one too.
    case 'order_rejected':
    case 'order_canceled':
    case 'order_schedule_canceled':
      if (!event.metadata.reason) return null;
      return (
        <EventDetailContainer>
          <MessageAuthor icon>{event.metadata.reason}</MessageAuthor>
        </EventDetailContainer>
      );

    case 'claim_estimates_updated': {
      const emptyValue = rootT('claim.estimates.empty_value');

      // La propiedad dice en qué unidad se lee el valor. Los eventos anteriores
      // a ese dato no la traen, y el helper los devuelve tal como se guardaron.
      const estimateProperty =
        event.metadata && 'claim_estimates_property' in event.metadata
          ? event.metadata.claim_estimates_property
          : null;

      const format = (value?: string | null) =>
        formatClaimEstimateValue(estimateProperty, value) ?? emptyValue;

      const isValueRestated =
        !!event.metadata.old_value &&
        event.metadata.old_value === event.metadata.new_value;

      return (
        <EventDetailContainer>
          <div className='flex flex-row items-center gap-1'>
            {!!event.metadata.old_value && !isValueRestated && (
              <>
                <Badge variant='outline'>
                  {format(event.metadata.old_value)}
                </Badge>
                <IconArrowRight className='w-4 h-4 text-muted-foreground mx-2' />
              </>
            )}
            <Badge variant='outline'>{format(event.metadata.new_value)}</Badge>
          </div>
          {event.metadata.reason && (
            <div className='mt-2'>
              <p className='text-xs text-muted-foreground italic'>
                Motivo: "{event.metadata.reason}"
              </p>
            </div>
          )}
        </EventDetailContainer>
      );
    }

    case 'offer_agreement_expired':
    case 'offer_agreement_rejected':
    case 'offer_agreement_completed':
    case 'offer_agreement_cancelled':
    case 'offer_agreement_created':
    case 'offer_agreement_dispatch_failed':
    case 'offer_agreement_recipient_submitted':
      return (
        <EventDetailContainer className='space-y-3'>
          {/* El motivo lo escribe la compañía, acá o en el tablero de
              AutoSign: al reclamante solo le llega el motivo público del
              ofrecimiento, en su propio evento. */}
          {event.type === 'offer_agreement_cancelled' &&
            isInsurer &&
            event.metadata.cancelled_reason && (
              <MessageAuthor>{event.metadata.cancelled_reason}</MessageAuthor>
            )}
          {event.type === 'offer_agreement_dispatch_failed' && (
            <MessageAuthor>
              {rootT(
                `offer.agreement.dispatch.failure.${event.metadata.failure_code}`,
              )}
            </MessageAuthor>
          )}
          {event.type === 'offer_agreement_rejected' && (
            <MessageAuthor>{event.metadata.rejected_reason}</MessageAuthor>
          )}
          <EventDetailList>
            <Badge variant={'outline'}>
              {event.metadata.offer_agreement_name}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'file_request_uploaded':
      return (
        <EventDetailContainer>
          <FileList className='w-min flex flex-row flex-wrap items-center gap-2'>
            {event.details.map((detail) => {
              if (detail.object_type !== 'file') return;

              return (
                <a
                  className='hover:underline'
                  target='_blank'
                  href={detail.file.url}
                >
                  <FileListItem className='h-6 mr-2'>
                    <FileListLabel
                      mimetype={detail.file.mimetype!}
                      className='w-72 [&>svg]:w-4 [&>svg]:h-4'
                    >
                      {detail.file.stored_name}
                    </FileListLabel>
                  </FileListItem>
                </a>
              );
            })}
          </FileList>
        </EventDetailContainer>
      );

    case 'claim_file_uploaded': {
      if (event.metadata?.file_tags?.length === undefined) return null;
      return (
        <EventDetailContainer>
          <EventDetailList>
            {(event.metadata?.file_tags || []).map((file_tag) => {
              return (
                <FileListItem className='h-[1.625rem] mr-2 p-1 border border-stone-300 w-fit'>
                  <FileListLabel
                    mimetype={event.metadata?.mimetype || ''}
                    className='[&>svg]:w-4 [&>svg]:h-4'
                    textClassName='text-foreground font-medium text-base_brand'
                  >
                    {file_tag}
                  </FileListLabel>
                </FileListItem>
              );
            })}
          </EventDetailList>
        </EventDetailContainer>
      );
    }

    case 'file_requested': {
      const [fileRequest] = event.details;

      const placeholders =
        fileRequest?.object_type === 'file_request' &&
        !!fileRequest.file_request
          ? fileRequest.file_request?.placeholders?.map((placeholder) => ({
              tagName: placeholder.tag.name,
            }))
          : event.metadata.placeholders?.map((placeholder) => ({
              tagName: placeholder.tag,
            }));

      return (
        <EventDetailContainer>
          <EventDetailList>
            {(placeholders || []).map((placeholder) => {
              return (
                <Badge
                  variant={'outline'}
                  key={placeholder.tagName}
                  className='border-primary shadow-none text-base_brand'
                >
                  {placeholder.tagName}
                </Badge>
              );
            })}
          </EventDetailList>
        </EventDetailContainer>
      );
    }

    case 'file_request_placeholder_cancelled': {
      const tagName = event.metadata?.tag_name;
      const reason = event.metadata?.reason;

      return (
        <EventDetailContainer>
          <p>
            {isTriggeredByAuthUser ? 'Cancelaste' : 'canceló'} la solicitud del
            documento <span className='font-semibold'>{tagName}</span>
            {reason && (
              <span className='text-muted-foreground'> - Motivo: {reason}</span>
            )}
          </p>
        </EventDetailContainer>
      );
    }

    case 'claim_form_step_view':
      return (
        <EventDetailContainer>
          <Badge variant={'outline'}>{t(event.metadata.step)}</Badge>
        </EventDetailContainer>
      );

    case 'sinister_complaint_chat_message_send':
    case 'sinister_claim_chat_message_send':
      return (
        <EventDetailContainer>
          <p className='italic text-foreground text-base_brand whitespace-pre-wrap'>
            {event.metadata.message}
          </p>
        </EventDetailContainer>
      );

    case 'claim_form_step_completed':
      return (
        <EventDetailContainer>
          <Badge variant={'outline'}>{t(event.metadata.step)}</Badge>
        </EventDetailContainer>
      );

    case 'claim_updated': {
      const diffs = computeEventDiffs(event.metadata.diff);

      return (
        <EventDetailContainer>
          <ul className='font-normal text-foreground-secondary list-none'>
            {diffs.map((diff, index) => (
              <li key={index}>{diff}</li>
            ))}
          </ul>
        </EventDetailContainer>
      );
    }

    case 'claim_responsibility_returned':
      if (!event.metadata.reason) return;

      return (
        <EventDetailContainer>
          <p>
            y dejo el siguiente motivo:
            <span className='text-base_brand text-muted-foreground italic mt-2'>
              "{event.metadata.reason}"
            </span>
          </p>
        </EventDetailContainer>
      );

    case 'claim_derived':
      return (
        <EventDetailContainer>
          <p>
            y {isTriggeredByAuthUser ? 'Dejaste' : 'dejo'} el siguiente motivo:
            <span className='text-base_brand text-muted-foreground italic mt-2'>
              "{event.metadata.reason}"
            </span>
          </p>
        </EventDetailContainer>
      );

    case 'claim_derived_returned':
      return (
        <EventDetailContainer>
          {event.metadata.reason && (
            <p>
              y {isTriggeredByAuthUser ? 'Dejaste' : 'dejo'} el siguiente
              motivo:
              <span className='text-base_brand text-muted-foreground italic mt-2'>
                "{event.metadata.reason}"
              </span>
            </p>
          )}
          {event.metadata.restored_status_name && (
            <p>Estado restaurado a "{event.metadata.restored_status_name}".</p>
          )}
        </EventDetailContainer>
      );

    case 'claim_derivation_canceled':
      return (
        <EventDetailContainer>
          <p>
            {event.metadata.canceled_automatically
              ? 'Motivo:'
              : 'con el motivo:'}
            <span className='text-base_brand text-muted-foreground italic mt-2'>
              "{event.metadata.reason}"
            </span>
          </p>
          {event.metadata.restored_status_name && (
            <p>Estado restaurado a "{event.metadata.restored_status_name}".</p>
          )}
        </EventDetailContainer>
      );

    case 'offer_canceled':
      // Third users receive this event with `reason` already replaced by the
      // public one server-side; `public_reason` only survives for company
      // users, where both motives are shown.
      return (
        <EventDetailContainer>
          <p>
            por el motivo:{' '}
            <span className='italic'>"{event.metadata.reason}"</span>
          </p>
          {event.metadata.public_reason && (
            <p>
              {rootT('claim.negotiation.cancel.public_reason_display')}:{' '}
              <span className='italic break-words max-w-full'>
                "{event.metadata.public_reason}"
              </span>
            </p>
          )}
        </EventDetailContainer>
      );

    case 'claim_created_documents_missing':
      return (
        <EventDetailContainer>
          <p>
            {event.metadata?.missing_documents?.length ? (
              <span className='font-light'>
                {`${event.metadata.missing_documents
                  ?.map((document) => rootT(`claim.document.${document}`))
                  .join(', ')}`}
              </span>
            ) : (
              ''
            )}
          </p>
        </EventDetailContainer>
      );

    case 'offer_rejected':
      return (
        <EventDetailContainer>
          <p>
            Motivo: <span className='italic'>"{event.metadata.reason}"</span>
            {event.metadata.third_party_user_requested_amount && (
              <>
                y el monto pretendido es
                <span className='italic'>
                  "{event.metadata.third_party_user_requested_amount}"
                </span>
              </>
            )}
          </p>
        </EventDetailContainer>
      );

    case 'pending_complaint_creation_failed':
      return (
        <EventDetailContainer>
          <p>
            Motivo: <span className='italic'>"{event.metadata.reason}"</span>
          </p>
        </EventDetailContainer>
      );

    case 'external_complaint_selection_failed':
      return (
        <EventDetailContainer>
          <p>
            Motivo: <span className='italic'>"{event.metadata.reason}"</span>
          </p>
        </EventDetailContainer>
      );

    case 'claim_ownership_transfer_requested':
      return (
        <EventDetailContainer>
          <p>"{event.metadata.destination_user_email}"</p>
        </EventDetailContainer>
      );

    case 'fraud_investigation_case_created':
      return (
        <EventDetailContainer>
          <EventDetailList>
            <Badge variant='outline'>
              Investigación #{event.metadata.external_case_id}
            </Badge>
            {event.metadata.reason && (
              <Badge variant='outline'>Motivo: {event.metadata.reason}</Badge>
            )}
            {event.metadata.creation_mode ===
              'associated_existing_kach_case' && (
              <Badge variant='secondary'>Asociado a caso existente</Badge>
            )}
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'fraud_news_answered': {
      const detail = findEventDetailObject(event.details, 'news_answer');
      const newsAnswer = detail?.news_answer;
      if (!newsAnswer) return null;

      return (
        <EventDetailContainer>
          <p className='italic text-base_brand min-h-7 flex flex-col justify-center whitespace-pre-wrap'>
            {newsAnswer.description}
          </p>
          {newsAnswer.files.length > 0 && (
            <FileList className='w-min flex flex-row flex-wrap items-center gap-2 mt-2'>
              {newsAnswer.files.map((file) => (
                <a
                  key={file.id}
                  className='hover:underline'
                  target='_blank'
                  href={file.url}
                >
                  <FileListItem className='h-6 mr-2'>
                    <FileListLabel
                      mimetype={file.mimetype!}
                      className='w-72 [&>svg]:w-4 [&>svg]:h-4'
                    >
                      {file.stored_name}
                    </FileListLabel>
                  </FileListItem>
                </a>
              ))}
            </FileList>
          )}
        </EventDetailContainer>
      );
    }

    case 'fraud_news_requested': {
      const detail = findEventDetailObject(event.details, 'news_request');
      const newsRequest = detail?.news_request;
      if (!newsRequest) return null;

      return (
        <EventDetailContainer>
          {newsRequest.annotation && (
            <p className='italic text-base_brand min-h-7 flex flex-col justify-center whitespace-pre-wrap'>
              {newsRequest.annotation}
            </p>
          )}
          {newsRequest.files.length > 0 && (
            <FileList className='w-min flex flex-row flex-wrap items-center gap-2 mt-2'>
              {newsRequest.files.map((file) => (
                <a
                  key={file.id}
                  className='hover:underline'
                  target='_blank'
                  href={file.url}
                >
                  <FileListItem className='h-6 mr-2'>
                    <FileListLabel
                      mimetype={file.mimetype!}
                      className='w-72 [&>svg]:w-4 [&>svg]:h-4'
                    >
                      {file.original_name}
                    </FileListLabel>
                  </FileListItem>
                </a>
              ))}
            </FileList>
          )}
        </EventDetailContainer>
      );
    }

    case 'fraud_claim_result_updated':
      return (
        <EventDetailContainer>
          <EventDetailList>
            {event.metadata.ref_id && (
              <Badge variant='outline'>Reclamo {event.metadata.ref_id}</Badge>
            )}
            <Badge variant='outline'>
              Resultado: {fraudClaimResults(`${event.metadata.new_result}`)}
            </Badge>
          </EventDetailList>
        </EventDetailContainer>
      );

    case 'fraud_closed':
      return (
        <EventDetailContainer>
          <p>Resultado: {fraudResults(`${event.metadata.result}`)} </p>
          {!!event.metadata.claims?.length && (
            <EventDetailList>
              {event.metadata.claims.map((claimResult, index) => (
                <Badge variant='outline' key={index}>
                  Reclamo {claimResult.ref_id ?? 'sin referencia'}: Resultado{' '}
                  {fraudClaimResults(`${claimResult.result}`)}
                </Badge>
              ))}
            </EventDetailList>
          )}
        </EventDetailContainer>
      );

    case 'fraud_reopened':
      return (
        <EventDetailContainer>
          <p>Estado: {fraudInternalStatus(`${event.metadata.status}`)}</p>
        </EventDetailContainer>
      );

    case 'fraud_updated': {
      const { status, external_status, instance, lab_name, responsible_name } =
        event.metadata;

      if (
        !status &&
        !external_status &&
        !instance &&
        !lab_name &&
        !responsible_name
      )
        return null;

      return (
        <EventDetailContainer>
          <EventDetailList>
            {status && (
              <Badge variant='outline'>Estado: {fraudStatus(status)}</Badge>
            )}
            {lab_name && <Badge variant='outline'>Estudio: {lab_name}</Badge>}
            {responsible_name && (
              <Badge variant='outline'>Responsable: {responsible_name}</Badge>
            )}
            {external_status && (
              <Badge variant='outline'>Estado en Kach: {external_status}</Badge>
            )}
            {instance && <Badge variant='outline'>Instancia: {instance}</Badge>}
          </EventDetailList>
        </EventDetailContainer>
      );
    }

    case 'claim_status_communication_sent':
      return (
        <EventDetailContainer>
          <p>
            por el cambio de estado a{' '}
            <strong className='font-semibold'>
              {event.metadata.new_status_name}
            </strong>
          </p>
        </EventDetailContainer>
      );

    default:
      return null;
  }
};

const Content = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { index } = useActivityContext();

  return (
    <div
      className={cn(
        'text-base_brand flex flex-col',
        { 'mt-2': index !== 0 },
        className,
      )}
    >
      {children}
    </div>
  );
};

const TriggeredByAvatar = ({
  triggeredBy,
  size = 'sm',
}: {
  triggeredBy: EventComplete['triggered_by'];
  size?: 'xs' | 'sm' | 'md' | 'lg';
}) => {
  return (
    <Avatar size={size}>
      <AvatarImage
        src={triggeredBy?.profile_photo || '/images/small-user-placeholder.png'}
      />
      <AvatarFallback className='text-xs'>
        {triggeredBy ? getInitialsFromUser(triggeredBy) : ''}
      </AvatarFallback>
    </Avatar>
  );
};

const Marker = () => {
  const { index, event } = useActivityContext();

  const Icon = iconsByEvents[event.type];

  return (
    <div
      className={cn('absolute -left-3', {
        'top-5': index !== 0,
      })}
    >
      <div className='rounded-full p-1 bg-card shadow'>
        {Icon && <Icon className='w-4 h-4 text-muted-foreground' />}
      </div>
    </div>
  );
};

const Header = ({
  children,
  className,
  eventType,
}: {
  children: React.ReactNode;
  className?: string;
  eventType?: EventComplete['type'];
}) => {
  return (
    <div
      className={cn(
        'flex flex-col md:flex-row md:items-center gap-2 md:justify-between p-2 rounded-xl',
        className,
        {
          'bg-stone-100': eventType === 'claim_comment_created',
        },
      )}
    >
      {children}
    </div>
  );
};

const findEventDetailObject = <T extends EventDetailObjects>(
  details: EventDetailUnion[],
  object: T,
) =>
  details.find(
    (detail): detail is Extract<EventDetailUnion, { object_type: T }> =>
      detail.object_type === object,
  ) as Extract<EventDetailUnion, { object_type: T }>;

const buildComplaintPersonName = (
  email: string | undefined,
  details: EventDetailUnion[],
) => {
  if (email) return email;

  const detail = findEventDetailObject(details, 'user');

  return detail?.user ? buildUserDisplayName(detail.user) : '';
};

export const computeEventDiffs = (
  diff: Array<{
    type: string;
    path: Array<string | number>;
    oldValue?: any;
    value?: any;
  }>,
) => {
  const t = useTranslations();

  const changes = diff
    .filter((diff) => {
      return [diff.oldValue, diff.value].every((val) => {
        if (val === null) return true;
        return typeof val !== 'object' && !Array.isArray(val);
      });
    })
    .map((diff) => {
      if (diff.type !== 'CHANGE') return null;

      if (diff.oldValue === diff.value) return null;

      const segments = diff.path.filter(
        (path): path is string => typeof path === 'string',
      );

      const label = segments
        .map((segment, index) => {
          const prevSegments = segments.slice(0, index);

          return t(
            `claim.attributes${
              prevSegments.length ? `.${prevSegments.join('.')}` : ''
            }.${segment}.label`,
          );
        })
        .join('/');

      const path = `claim.attributes.${diff.path
        .filter((path): path is string => typeof path === 'string')
        .join('.')}`;

      return (
        <span>
          {label}
          {diff.oldValue && (
            <>
              {' de '}
              <strong className='font-semibold'>
                {parseSuperType(diff.oldValue, () =>
                  t(`${path}.value.${diff.oldValue}`, {}, diff.oldValue || ''),
                )}
              </strong>
            </>
          )}
          {' a '}
          <strong className='font-semibold'>
            {parseSuperType(diff.value, () =>
              t(`${path}.value.${diff.value}`, {}, diff.value || ''),
            )}
          </strong>
        </span>
      );
    })
    .filter(Boolean); // Remove null values

  return changes;
};

// Every order event carries the order's REF-ID so the actor line stays
// unambiguous in the claim activity, where a claim can hold many orders. Renders
// a trailing " ORD-12"; empty for (older) events that predate the field.
const orderRefSuffix = (refId?: string | null): string =>
  refId ? ` ${refId}` : '';

// order_scheduling — the event's UTC ISO 8601, in the client's timezone.
const formatScheduledFor = (value?: string | null): string =>
  value ? format(new Date(value), 'dd/MM/yyyy HH:mm') : '';

// A paperclip + "N archivos adjuntos" hint when the novedad carries
// attachments; nothing otherwise.
const AttachmentsHint = ({ count }: { count?: number | null }) =>
  count && count > 0 ? (
    <span className='inline-flex items-center gap-1 text-muted-foreground text-xs ml-2 mt-0.5'>
      <IconPaperclip className='w-3 h-3' />
      {count}
    </span>
  ) : null;

const EventAction = ({
  authUser,
  path,
}: {
  authUser: AuthInfoResponseBody;
  path?: string;
}) => {
  const { event } = useActivityContext();
  const t = useTranslations();

  const isTriggeredByAuthUser = event.triggered_by_id === authUser?.id;

  // Resolved once; used by every order case below. The `in` guard keeps it
  // type-safe across the event metadata union (no cast).
  const orderRef =
    event.metadata && 'order_ref_id' in event.metadata
      ? orderRefSuffix(event.metadata.order_ref_id)
      : '';

  switch (event.type) {
    case 'claim_comment_created':
      return <>{isTriggeredByAuthUser ? 'Comentaste' : 'comentó'}</>;

    case 'complaint_updated':
      return (
        <>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} datos de la
          denuncia
        </>
      );

    case 'alert_sla_total_progress':
      return (
        <>
          notifica que el SLA {event.metadata.sla_name} esta al{' '}
          {event.metadata.sla_total_progress}% de su progreso
        </>
      );

    case 'alert_sla_objective_progress':
      return (
        <>
          notifica que el{' '}
          {t(`sla.types.${event.metadata.sla_objective_reference_type}`)}{' '}
          {event.metadata.sla_objective_reference_name} del SLA{' '}
          {event.metadata.sla_name} esta al{' '}
          {event.metadata.sla_objective_progress}% de su progreso
        </>
      );

    case 'complaint_responsible_assigned': {
      return (
        <>
          {isTriggeredByAuthUser ? 'Asignaste' : 'asignó'} a{' '}
          {buildComplaintPersonName(
            event.metadata.responsible_user_email,
            event.details,
          )}{' '}
          como responsable
        </>
      );
    }

    case 'complaint_collaborator_assigned': {
      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} a{' '}
          {buildComplaintPersonName(
            event.metadata.collaborator_user_email,
            event.details,
          )}{' '}
          como colaborador
        </>
      );
    }

    case 'complaint_collaborator_unassigned': {
      return (
        <>
          {isTriggeredByAuthUser ? 'Removiste' : 'removió'} a{' '}
          {buildComplaintPersonName(
            event.metadata.collaborator_user_email,
            event.details,
          )}{' '}
          como colaborador
        </>
      );
    }

    case 'complaint_collaborator_unassigned':
      return (
        <>{isTriggeredByAuthUser ? 'Removiste' : 'removió'} un colaborador</>
      );

    case 'complaint_estimates_updated':
      return (
        <>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} las{' '}
          <EventActionLink linkText='estimaciones' url={`${path}/estimates`} />
        </>
      );

    case 'external_complaint_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} la denuncia en el
          sistema tercero
        </>
      );

    case 'complaint_rejected':
      return (
        <>{isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} la denuncia</>
      );

    case 'external_complaint_approved':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aprobaste' : 'aprobó'} la denuncia en el
          sistema tercero
        </>
      );

    case 'complaint_approved':
      return <>{isTriggeredByAuthUser ? 'Aprobaste' : 'aprobó'} la denuncia</>;

    case 'external_complaint_authorized':
      return (
        <>
          {isTriggeredByAuthUser ? 'Autorizaste' : 'autorizó'} la denuncia en el
          sistema tercero
        </>
      );

    case 'complaint_authorized':
      return (
        <>{isTriggeredByAuthUser ? 'Autorizaste' : 'autorizó'} la denuncia</>
      );

    case 'external_complaint_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Creaste' : 'creó'} la denuncia en el sistema
          tercero
        </>
      );

    case 'rfp_expired':
      return (
        <>{isTriggeredByAuthUser ? 'Expiraste' : 'expiró'} la licitación</>
      );

    case 'claim_updated': {
      if (isTriggeredByAuthUser) {
        return (
          <div className='flex flex-col items-start w-full'>
            <p>
              Actualizaste el{' '}
              <EventActionLink linkText='reclamo' url={`${path}`} />
              {': '}
            </p>
          </div>
        );
      }
      return (
        <div className='flex flex-col items-start space-x-2 w-full'>
          <p>
            actualizó el <EventActionLink linkText='reclamo' url={`${path}`} />
            {': '}
          </p>
        </div>
      );
    }

    case 'claim_estimates_updated': {
      const estimateProperty =
        event.metadata && 'claim_estimates_property' in event.metadata
          ? event.metadata.claim_estimates_property
          : null;

      return (
        <>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'}{' '}
          {t(
            `claim.estimates.activity.${estimateProperty}`,
            undefined,
            'un dato',
          )}{' '}
          en la{' '}
          <EventActionLink linkText='estimación' url={`${path}/estimates`} />
        </>
      );
    }

    case 'pending_file_request_upload':
      return (
        <>
          {isTriggeredByAuthUser ? 'Notificaste' : 'notificó'} al reclamante
          usuario sobre la documentación pendiente
        </>
      );

    case 'pending_offer_response_internal':
      return (
        <>
          {isTriggeredByAuthUser ? 'Notificaste' : 'notificó'} al tramitador
          responsable sobre el ofrecimiento pendiente sin responder
        </>
      );

    case 'pending_offer_response':
      return (
        <>
          {isTriggeredByAuthUser ? 'Notificaste' : 'notificó'} al reclamante
          usuario sobre el ofrecimiento pendiente sin responder
        </>
      );

    case 'pending_offer_agreement_response':
      return (
        <>
          {isTriggeredByAuthUser ? 'Notificaste' : 'notificó'} al reclamante
          usuario sobre la conformidad sin completar
        </>
      );

    case 'pending_offer_agreement_response_internal':
      return (
        <>
          {isTriggeredByAuthUser ? 'Notificaste' : 'notificó'} al tramitador
          responsable sobre la conformidad sin completar
        </>
      );

    case 'claim_documentation_requested':
      return (
        <>{isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} documentación</>
      );

    case 'claim_ownership_assigned':
      return (
        <>
          {isTriggeredByAuthUser ? 'Asignaste' : 'asignó'} como reclamante
          usuario a: {event.metadata.destination_user_name}
        </>
      );

    case 'claim_ownership_transfer_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} la solicitud de
          transferencia de propiedad del reclamo
        </>
      );

    case 'claim_ownership_transfer_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} la solicitud de
          transferencia de propiedad del reclamo
        </>
      );

    case 'claim_ownership_transfer_requested':
      return (
        <>
          {isTriggeredByAuthUser ? 'Enviaste' : 'envió'} una solicitud de
          transferencia de propiedad del reclamo al usuario:
        </>
      );

    case 'contract_report_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} un reporte en el
          contrato: "{event.metadata.contract_name}"
        </>
      );

    case 'order_report_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} un reporte en la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'contract_invoice_uploaded':
      return (
        <>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'} una factura en el
          contrato: "{event.metadata.contract_name}"
        </>
      );

    case 'order_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Creaste' : 'creó'} la orden de trabajo{' '}
          <b>{orderRef}</b>: {event.metadata.order_name}.
        </>
      );

    case 'contract_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Creaste' : 'creó'} el contrato:
          {event.metadata.contract_name}
        </>
      );

    case 'rfp_bid_submitted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Enviaste' : 'envió'} su oferta en la
          licitación
        </>
      );

    case 'rfp_bid_winner_selected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Seleccionaste' : 'seleccionó'} al proveedor
          ganador: "{event.metadata.vendor_contact_name}"
        </>
      );

    case 'rfp_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Creaste' : 'creó'} la licitación:{' '}
          <EventActionLink
            linkText={event.metadata.rfp_name}
            url={`${path}/rfps`}
          />
        </>
      );

    case 'rfp_canceled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Cancelaste' : 'canceló'} la licitación:{' '}
          <EventActionLink
            linkText={event.metadata.canceled_reason}
            url={`${path}/rfps`}
          />
        </>
      );

    case 'order_updates_requested':
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} mensajes en la
          orden de trabajo <b>{orderRef}</b>
          <AttachmentsHint count={event.metadata.files_count} />
        </>
      );

    case 'contract_updates_requested':
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} novedades del
          contrato
        </>
      );

    case 'contract_updates_published':
      return (
        <>
          {isTriggeredByAuthUser ? 'Publicaste' : 'publicó'} novedades del
          contrato
        </>
      );

    case 'order_updates_published':
      return (
        <>
          {isTriggeredByAuthUser ? 'Enviaste' : 'envió'} un mensaje en la orden
          de trabajo <b>{orderRef}</b>
          <AttachmentsHint count={event.metadata.files_count} />
        </>
      );

    case 'order_document_uploaded': {
      const documents =
        event.metadata.files_count === 1
          ? 'un documento'
          : `${event.metadata.files_count} documentos`;

      // order_document_import — imported documents were linked from the record,
      // not uploaded, and the copy has to say so.
      return event.metadata.source === 'imported' ? (
        <>
          {isTriggeredByAuthUser ? 'Adjuntaste' : 'adjuntó'} {documents} del
          expediente a la orden de trabajo <b>{orderRef}</b>
        </>
      ) : (
        <>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'} {documents} a la orden
          de trabajo <b>{orderRef}</b>
        </>
      );
    }

    case 'order_document_removed':
      return (
        <>
          {isTriggeredByAuthUser ? 'Eliminaste' : 'eliminó'} un documento de la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'order_required_document_uploaded':
      return (
        <>
          {isTriggeredByAuthUser ? 'Cargaste' : 'cargó'} el documento{' '}
          <b>{event.metadata.document_name}</b> de la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_required_document_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aprobaste' : 'aprobó'} el documento{' '}
          <b>{event.metadata.document_name}</b> de la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_required_document_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} el documento{' '}
          <b>{event.metadata.document_name}</b> de la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_required_document_reset':
      return (
        <>
          {isTriggeredByAuthUser ? 'Deshiciste' : 'deshizo'} la revisión del
          documento <b>{event.metadata.document_name}</b> de la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'contract_report_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} un reporte de
          contrato
        </>
      );

    case 'order_report_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} un reporte de la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'contract_report_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} un reporte de
          contrato
        </>
      );

    case 'order_report_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} un reporte de la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'appraisal_invoice_uploaded':
      return (
        <>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'} una factura de la
          evaluación
        </>
      );

    case 'appraisal_updates_requested':
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} novedades de la
          evaluación
        </>
      );

    case 'appraisal_updates_published':
      return (
        <>
          {isTriggeredByAuthUser ? 'Publicaste' : 'publicó'} novedades sobre la
          evaluación
        </>
      );

    case 'appraisal_report_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} un informe de
          evaluación
        </>
      );

    case 'appraisal_report_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} un informe de
          evaluación
        </>
      );

    case 'appraisal_report_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} un informe de
          evaluación
        </>
      );

    // Los cierres y el avance de la firma los emite el sistema al recibir el
    // webhook de AutoSign (o al reconciliar), por eso van en la forma
    // "notifica que…" (precedente: alertas de SLA y pruebas de trabajo).
    case 'offer_agreement_completed':
      return <>{t('activity.offer_agreement_completed')}</>;

    case 'offer_agreement_created':
      return (
        <>
          {t(
            isTriggeredByAuthUser
              ? 'activity.offer_agreement_created.own'
              : 'activity.offer_agreement_created.other',
          )}
        </>
      );

    case 'offer_agreement_dispatch_failed':
      return <>{t('activity.offer_agreement_dispatch_failed')}</>;

    case 'claim_sinister_changed':
      return (
        <>
          {t('activity.claim_sinister_changed', {
            ref_id: event.metadata.ref_id || event.metadata.claim_id,
            complaint: event.metadata.external_complaint_external_id,
          })}
        </>
      );

    case 'claim_derivation_restore_status_updated':
      return (
        <>
          {t('activity.claim_derivation_restore_status_updated', {
            previous: event.metadata.previous_restore_status_name,
            status: event.metadata.restore_status_name,
          })}
        </>
      );

    case 'offer_agreement_recipient_submitted':
      return (
        <>
          {t('activity.offer_agreement_recipient_submitted', {
            name:
              event.metadata.recipient_name || event.metadata.recipient_email,
          })}
        </>
      );

    case 'offer_agreement_expired':
      return <>{t('activity.offer_agreement_expired')}</>;

    case 'offer_agreement_rejected':
      return <>{t('activity.offer_agreement_rejected')}</>;

    // La anulación local la hace el tramitador; la cancelación desde el tablero
    // de AutoSign llega por webhook y queda a nombre del sistema. El actor no
    // sirve para distinguirlas: al reclamante no se le manda su email.
    case 'offer_agreement_cancelled':
      if (event.metadata.cancelled_by_provider)
        return <>{t('activity.offer_agreement_cancelled.provider')}</>;

      return (
        <>
          {t(
            isTriggeredByAuthUser
              ? 'activity.offer_agreement_cancelled.own'
              : 'activity.offer_agreement_cancelled.other',
          )}
        </>
      );

    case 'offer_expired':
      return <>expiro un ofrecimiento</>;

    case 'offer_rejected': {
      if (event.metadata.on_behalf_of_claimant) {
        if (authUser?.type === 'insurer')
          return (
            <div className='flex flex-wrap items-center gap-1'>
              <p>
                {t(
                  isTriggeredByAuthUser
                    ? 'activity.offer_rejected_on_behalf.own'
                    : 'activity.offer_rejected_on_behalf.other',
                )}
                <EventActionLink
                  linkText={event.metadata.offer_name}
                  url={`${path}/offers`}
                />
              </p>
            </div>
          );

        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              {t('activity.offer_rejected_on_behalf.claimant')}
              <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
            </p>
          </div>
        );
      }
      if (authUser?.type === 'insurer') {
        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              rechazó el ofrecimiento
              <EventActionLink
                linkText={event.metadata.offer_name}
                url={`${path}/offers`}
              />
            </p>
          </div>
        );
      }
      if (isTriggeredByAuthUser) {
        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              Rechazaste el
              <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
            </p>
          </div>
        );
      }
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            Rechazó el
            <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
          </p>
        </div>
      );
    }

    case 'offer_canceled': {
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Anulaste' : 'anuló'} el
            <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
          </p>
        </div>
      );
    }

    case 'offer_created': {
      if (authUser?.type === 'insurer') {
        if (isTriggeredByAuthUser) {
          return (
            <div className='flex flex-wrap items-center gap-1'>
              <p>
                Enviaste el
                <EventActionLink
                  linkText='ofrecimiento'
                  url={`${path}/offers`}
                />
                {event.metadata.offer_name}
              </p>
            </div>
          );
        }
        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              envió el
              <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
              {event.metadata.offer_name}
            </p>
          </div>
        );
      }
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            te envió el
            <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
            {event.metadata.offer_name}
          </p>
        </div>
      );
    }

    case 'offer_accepted': {
      if (isTriggeredByAuthUser) {
        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              Aceptaste el
              <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
              {event.metadata.offer_name}
            </p>
          </div>
        );
      }
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            aceptó el
            <EventActionLink linkText='ofrecimiento' url={`${path}/offers`} />
            {event.metadata.offer_name}
          </p>
        </div>
      );
    }

    case 'fraud_news_answered':
      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} novedades a la
          investigación
        </>
      );

    case 'fraud_claim_result_updated':
      return (
        <>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} el resultado
          {event.metadata.ref_id
            ? ` del reclamo ${event.metadata.ref_id}`
            : ' de un reclamo'}
        </>
      );

    case 'fraud_news_requested':
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} novedades de la
          investigación
        </>
      );

    case 'fraud_investigation_case_created': {
      const wasAssociated =
        event.metadata.creation_mode === 'associated_existing_kach_case';
      if (wasAssociated) {
        return (
          <>
            {isTriggeredByAuthUser ? 'Derivaste' : 'derivó'} el siniestro a
            fraude (asociado a caso existente)
          </>
        );
      }
      return (
        <>
          {isTriggeredByAuthUser ? 'Derivaste' : 'derivó'} el siniestro a fraude
        </>
      );
    }

    case 'fraud_updated':
      switch (event.metadata.kach_event) {
        case 'case_investigation_derived':
          return (
            <>
              {isTriggeredByAuthUser ? 'Derivaste' : 'derivó'} la investigación
              a un estudio
            </>
          );
        case 'case_taken':
          return (
            <>{isTriggeredByAuthUser ? 'Tomaste' : 'tomó'} la investigación</>
          );
        case 'case_assigned':
          return (
            <>
              {isTriggeredByAuthUser ? 'Asignaste' : 'asignó'} la investigación
            </>
          );
        case 'case_responsibility_restored':
          return (
            <>
              {isTriggeredByAuthUser ? 'Devolviste' : 'devolvió'} la
              responsabilidad de la investigación
            </>
          );
        default:
          return (
            <>
              {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} la
              investigación
            </>
          );
      }

    case 'fraud_closed':
      return (
        <>{isTriggeredByAuthUser ? 'Cerraste' : 'cerró'} la investigación</>
      );

    case 'fraud_reopened':
      return (
        <>{isTriggeredByAuthUser ? 'Reabriste' : 'reabrió'} la investigación</>
      );

    case 'claim_form_step_completed':
      return (
        <>
          {isTriggeredByAuthUser ? 'Completaste' : 'completó'} un paso del
          formulario
        </>
      );

    case 'claim_form_step_view':
      return (
        <>
          {isTriggeredByAuthUser ? 'Visitaste' : 'visitó'} un paso del
          formulario
        </>
      );

    case 'sinister_complaint_chat_message_send':
    case 'sinister_claim_chat_message_send': {
      if (isTriggeredByAuthUser) {
        return (
          <>
            Enviaste un{' '}
            <EventActionLink linkText='mensaje' url={`${path}/messages`} />
          </>
        );
      }
      return (
        <>
          envió un{' '}
          <EventActionLink linkText='mensaje' url={`${path}/messages`} />
        </>
      );
    }

    case 'file_request_uploaded':
      return (
        <>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'}{' '}
          <EventActionLink linkText='archivos' url={`${path}/documents`} />{' '}
          solicitados
        </>
      );

    case 'claim_created':
      return <>{isTriggeredByAuthUser ? 'Creaste' : 'creó'} el reclamo</>;

    case 'file_requested': {
      const detail = findEventDetailObject(event.details, 'file_request');

      if (detail) {
        if (authUser?.type !== 'insurer') {
          return (
            <>
              te solicitó los siguientes{' '}
              <EventActionLink linkText='archivos' url={`${path}/documents`} />
            </>
          );
        }
        return (
          <>
            le solicitó al reclamante los siguientes{' '}
            <EventActionLink linkText='archivos' url={`${path}/documents`} />
          </>
        );
      }
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} los siguientes{' '}
          <EventActionLink linkText='archivos' url={`${path}/documents`} />
        </>
      );
    }

    case 'file_request_placeholder_cancelled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Cancelaste' : 'canceló'} una solicitud de{' '}
          <EventActionLink linkText='documentación' url={`${path}/documents`} />
        </>
      );

    case 'order_invoice_uploaded':
      return (
        <>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'} una factura de la orden
          de trabajo
          <b>{orderRef}</b>
        </>
      );

    case 'claim_responsibility_returned': {
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Retornaste' : 'retornó'} el reclamo a{' '}
            {event.metadata.responsible_user_first_name}{' '}
            {event.metadata.responsible_user_last_name}
            {event.metadata.responsible_user_email &&
              ` (${event.metadata.responsible_user_email})`}
          </p>
        </div>
      );
    }

    case 'claim_derived_returned': {
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Retornaste' : 'retornó'} la derivación del
            reclamo a {event.metadata.responsible_user_first_name}{' '}
            {event.metadata.responsible_user_last_name}
            {event.metadata.responsible_user_email &&
              ` (${event.metadata.responsible_user_email})`}
          </p>
        </div>
      );
    }

    case 'claim_derivation_canceled': {
      if (event.metadata.canceled_automatically)
        return (
          <div className='flex flex-wrap items-center gap-1'>
            <p>
              canceló automáticamente la derivación del reclamo
              {event.metadata.responsible_user_first_name &&
                ` y lo devolvió a ${event.metadata.responsible_user_first_name} ${event.metadata.responsible_user_last_name}`}
            </p>
          </div>
        );

      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Recuperaste' : 'recuperó'} el reclamo
            derivado
            {event.metadata.previous_responsible_user_id &&
              ` que tenía ${event.metadata.previous_responsible_user_first_name} ${event.metadata.previous_responsible_user_last_name}`}{' '}
            y lo devolvió a {event.metadata.responsible_user_first_name}{' '}
            {event.metadata.responsible_user_last_name}
            {event.metadata.responsible_user_email &&
              ` (${event.metadata.responsible_user_email})`}
          </p>
        </div>
      );
    }

    case 'pending_complaint_requested':
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Has' : 'ha'} intentado crear una denuncia
            de oficio vinculando los reclamos:{' '}
          </p>
          <p>
            {event.metadata.claims
              .map((claim) => `${claim.ref_id || claim.id}`)
              .join(', ')}
          </p>
        </div>
      );

    case 'pending_complaint_created':
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Creaste' : 'creó'} una denuncia de oficio
            vinculando los reclamos:{' '}
          </p>
          <p>
            {event.metadata.claims
              .map((claim) => `${claim.ref_id || claim.id}`)
              .join(', ')}
          </p>
        </div>
      );

    case 'pending_complaint_creation_failed':
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            No se ha podido crear la denuncia de oficio vinculada a los
            reclamos:{' '}
          </p>
          <p>
            {event.metadata.claims
              .map((claim) => `${claim.ref_id || claim.id}`)
              .join(', ')}
          </p>
        </div>
      );

    case 'external_complaint_selected':
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Has' : 'ha'} intentado vincular los
            reclamos:{' '}
            {event.metadata.claims
              .map((claim) => `${claim.ref_id || claim.id}`)
              .join(', ')}
          </p>
          <p>a la denuncia {event.metadata.external_complaint_external_id}</p>
        </div>
      );

    case 'external_complaint_selection_failed':
      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            No se ha podido vincular los reclamos:{' '}
            {event.metadata.claims
              .map((claim) => `${claim.ref_id || claim.id}`)
              .join(', ')}
          </p>
          <p>a la denuncia {event.metadata.external_complaint_external_id}</p>
        </div>
      );

    case 'claim_derived': {
      const assignee = `${event.metadata.responsible_user_first_name} ${
        event.metadata.responsible_user_last_name
      }${
        event.metadata.responsible_user_email
          ? ` (${event.metadata.responsible_user_email})`
          : ''
      }`;

      return (
        <div className='flex flex-wrap items-center gap-1'>
          <p>
            {isTriggeredByAuthUser ? 'Derivaste' : 'derivó'} el reclamo{' '}
            {event.metadata.team_name
              ? `al grupo ${event.metadata.team_name}, asignado a ${assignee}`
              : `a ${assignee}`}
          </p>
        </div>
      );
    }

    case 'claim_responsible_assigned': {
      const detail = findEventDetailObject(event.details, 'user');

      const user = detail?.user
        ? { name: buildUserDisplayName(detail.user) }
        : {
            name: buildUserDisplayName({
              first_name: event.metadata.responsible_user_first_name,
              last_name: event.metadata.responsible_user_last_name,
              email: event.metadata.responsible_user_email,
            }),
          };

      const previousResponsibleId = event.metadata.previous_responsible_user_id;

      const actedOnOwnClaims =
        !previousResponsibleId ||
        previousResponsibleId === event.triggered_by?.id;

      if (event.metadata.assignment_reason === 'delegated_by_owner') {
        return (
          <>
            {t(
              isTriggeredByAuthUser
                ? 'activity.claim_delegated_by_owner.self'
                : 'activity.claim_delegated_by_owner.other',
              { responsible: user.name },
            )}
          </>
        );
      }

      if (event.metadata.assignment_reason === 'delegated_by_inactivity') {
        if (!actedOnOwnClaims) {
          const absentMember = buildUserDisplayName({
            first_name: event.metadata.previous_responsible_user_first_name,
            last_name: event.metadata.previous_responsible_user_last_name,
            email: event.metadata.previous_responsible_user_email,
          });

          return (
            <>
              {isTriggeredByAuthUser ? 'Delegaste' : 'delegó'} este reclamo de{' '}
              {absentMember} a {user.name}
            </>
          );
        }

        return (
          <>
            {isTriggeredByAuthUser
              ? 'Te encuentras inactivo.'
              : `se encuentra inactivo.`}{' '}
            Piramid asignó a {user.name} como nuevo responsable
          </>
        );
      }

      if (event.metadata.assignment_reason === 'substituted_by_inactivity') {
        return (
          <>
            {isTriggeredByAuthUser ? 'Reasignaste' : 'reasignó'} el reclamo a{' '}
            {user.name} porque el tramitador que debía recibirlo se encuentra
            inactivo
          </>
        );
      }

      if (event.metadata.assignment_reason === 'derivation_reassigned') {
        const previousHolder = buildUserDisplayName({
          first_name: event.metadata.previous_responsible_user_first_name,
          last_name: event.metadata.previous_responsible_user_last_name,
          email: event.metadata.previous_responsible_user_email,
        });

        return (
          <>
            {isTriggeredByAuthUser ? 'Reasignaste' : 'reasignó'} la derivación
            de {previousHolder} a {user.name}
          </>
        );
      }

      if (event.metadata.assignment_reason === 'team_reassigned') {
        const previousResponsible = buildUserDisplayName({
          first_name: event.metadata.previous_responsible_user_first_name,
          last_name: event.metadata.previous_responsible_user_last_name,
          email: event.metadata.previous_responsible_user_email,
        });

        return (
          <>
            {isTriggeredByAuthUser ? 'Reasignaste' : 'reasignó'} este reclamo de{' '}
            {previousResponsible} a {user.name}
          </>
        );
      }

      if (event.metadata.assignment_reason === 'delegated_claim_restored') {
        if (previousResponsibleId) {
          const previousHolder = buildUserDisplayName({
            first_name: event.metadata.previous_responsible_user_first_name,
            last_name: event.metadata.previous_responsible_user_last_name,
            email: event.metadata.previous_responsible_user_email,
          });

          return (
            <>
              {isTriggeredByAuthUser ? 'Devolviste' : 'devolvió'} este reclamo
              delegado de {previousHolder} a su dueño, {user.name}
            </>
          );
        }

        if (event.metadata.responsible_user_id !== event.triggered_by?.id) {
          return (
            <>
              {isTriggeredByAuthUser ? 'Devolviste' : 'devolvió'} este reclamo
              delegado a {user.name}
            </>
          );
        }

        return (
          <>
            {isTriggeredByAuthUser
              ? 'Recuperaste este reclamo delegado.'
              : `recuperó este reclamo delegado.`}{' '}
            Piramid asignó a {user.name} como responsable
          </>
        );
      }

      return (
        <>
          {isTriggeredByAuthUser ? 'Asignaste' : 'asignó'} a {user.name} como
          responsable
        </>
      );
    }

    case 'claim_collaborator_assigned': {
      const { user } = findEventDetailObject(event.details, 'user');

      if (!user) {
        return;
      }

      return (
        <>
          {isTriggeredByAuthUser ? 'Agregaste' : 'agregó'} a{' '}
          {buildUserDisplayName(user)} como colaborador
        </>
      );
    }

    case 'claim_collaborator_unassigned': {
      const { user } = findEventDetailObject(event.details, 'user');

      if (!user) {
        return;
      }

      return (
        <>
          {isTriggeredByAuthUser ? 'Removiste' : 'removió'} a{' '}
          {buildUserDisplayName(user)} como colaborador
        </>
      );
    }

    case 'complaint_sinister_cause_updated': {
      return (
        <p>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} la causa del
          siniestro de {event.metadata.previous_sinister_cause_name || ''}a{' '}
          {event.metadata.new_sinister_cause_name}
        </p>
      );
    }

    case 'sinister_external_status_updated': {
      return (
        <p>
          Se actualizó el estado del siniestro de '
          {event.metadata.previous_status}' a '{event.metadata.external_status}'
        </p>
      );
    }

    case 'complaint_status_updated':
    case 'claim_status_updated': {
      return (
        <p>
          {isTriggeredByAuthUser ? 'Actualizaste' : 'actualizó'} el estado de{' '}
          {event.metadata.previous_status_name} a{' '}
          {event.metadata.new_status_name}
        </p>
      );
    }

    case 'claim_status_communication_sent': {
      return (
        <p>
          envió una comunicación automática a{' '}
          <strong className='font-semibold'>
            {event.metadata.recipient_email}
          </strong>
        </p>
      );
    }

    case 'claim_file_uploaded': {
      return (
        <p>
          {isTriggeredByAuthUser ? 'Subiste' : 'subió'}{' '}
          <EventActionLink linkText='archivos' url={`${path}/documents`} />
        </p>
      );
    }

    case 'claim_created_documents_missing': {
      return (
        <p>
          {isTriggeredByAuthUser ? 'Dejaste' : 'dejó'}{' '}
          <EventActionLink
            linkText='documentación solicitada'
            url={`${path}/documents`}
          />{' '}
          sin adjuntar
        </p>
      );
    }

    // F1.4.3 — order lifecycle transitions.
    case 'order_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_canceled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Anulaste' : 'anuló'} la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    case 'order_completed':
      return (
        <>
          {isTriggeredByAuthUser ? 'Finalizaste' : 'finalizó'} la orden de
          trabajo
          <b>{orderRef}</b>
        </>
      );

    case 'order_reopened':
      return (
        <>
          {isTriggeredByAuthUser ? 'Reabriste' : 'reabrió'} la orden de trabajo{' '}
          <b>{orderRef}</b>
        </>
      );

    // order_work_proof — `created` lo dispara la aseguradora desde la pestaña
    // Inspecciones; los de resultado los emite el sistema al recibir el webhook,
    // por eso van en la forma "notifica que…" (precedente: alertas de SLA).
    case 'order_work_proof_created':
      return (
        <>
          {isTriggeredByAuthUser ? 'Solicitaste' : 'solicitó'} una prueba de
          trabajo en la orden <b>{orderRef}</b>
        </>
      );

    case 'order_work_proof_approved':
      return (
        <>
          notifica que la prueba de trabajo de la orden <b>{orderRef}</b> fue
          aprobada
        </>
      );

    case 'order_work_proof_disapproved':
      return (
        <>
          notifica que la prueba de trabajo de la orden <b>{orderRef}</b> fue
          desaprobada
        </>
      );

    case 'order_work_proof_blocked':
      return (
        <>
          notifica que la prueba de trabajo de la orden <b>{orderRef}</b> quedó
          bloqueada
        </>
      );

    // order_scheduling — either side can record it. The "from X to Y" comes from
    // the metadata, without querying the previous event.
    case 'order_scheduled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Coordinaste' : 'coordinó'} el trabajo de la
          orden <b>{orderRef}</b> para el{' '}
          <b>{formatScheduledFor(event.metadata.scheduled_for)}</b>
          {/* Null on events from before branches were part of the coordination. */}
          {event.metadata.scheduled_branch_name ? (
            <>
              {' '}
              en <b>{event.metadata.scheduled_branch_name}</b>
            </>
          ) : null}
        </>
      );

    case 'order_rescheduled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Recoordinaste' : 'recoordinó'} el trabajo de
          la orden <b>{orderRef}</b>
          {event.metadata.previous_scheduled_for ? (
            <>
              {' '}
              del{' '}
              <b>
                {formatScheduledFor(event.metadata.previous_scheduled_for)}
              </b>{' '}
              al <b>{formatScheduledFor(event.metadata.scheduled_for)}</b>
            </>
          ) : (
            <>
              {' '}
              para el <b>{formatScheduledFor(event.metadata.scheduled_for)}</b>
            </>
          )}
          {event.metadata.scheduled_branch_name ? (
            <>
              {' '}
              en <b>{event.metadata.scheduled_branch_name}</b>
            </>
          ) : null}
        </>
      );

    // order_scheduling — the coordination is voided; the order goes back to
    // unscheduled without the order itself being canceled.
    case 'order_schedule_canceled':
      return (
        <>
          {isTriggeredByAuthUser ? 'Anulaste' : 'anuló'} el turno del{' '}
          <b>{formatScheduledFor(event.metadata.previous_scheduled_for)}</b> de
          la orden <b>{orderRef}</b>
        </>
      );

    // F1.4.4 — deliverable (report/invoice) review.
    case 'order_report_reset':
      return (
        <>
          {isTriggeredByAuthUser ? 'Deshiciste' : 'deshizo'} la revisión de un
          reporte de la orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'order_invoice_accepted':
      return (
        <>
          {isTriggeredByAuthUser ? 'Aceptaste' : 'aceptó'} una factura de la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'order_invoice_rejected':
      return (
        <>
          {isTriggeredByAuthUser ? 'Rechazaste' : 'rechazó'} una factura de la
          orden de trabajo <b>{orderRef}</b>
        </>
      );

    case 'order_invoice_reset':
      return (
        <>
          {isTriggeredByAuthUser ? 'Deshiciste' : 'deshizo'} la revisión de una
          factura de la orden de trabajo <b>{orderRef}</b>
        </>
      );

    default:
      return event.type;
  }
};

const EventActionLink = ({
  linkText,
  url,
}: {
  linkText: string;
  url: string;
}) => {
  return (
    <Link href={url} className='text-base_brand underline underline-offset-4'>
      {' '}
      {linkText}{' '}
    </Link>
  );
};

const Action = ({
  triggeredBy,
  path,
  className,
}: {
  triggeredBy: EventComplete['triggered_by'];
  path?: string;
  className?: string;
}) => {
  const auth = useSharedAuth();
  const { event } = useActivityContext();

  const isTriggeredByAuthUser = triggeredBy?.id === auth?.user?.id;

  return (
    <div
      className={cn(
        'font-medium text-base_brand text-foreground flex flex-row md:flex-wrap items-start md:items-center [overflow-wrap:anywhere]',
        className,
      )}
    >
      <div className='flex-shrink-0 ml-0 mr-1'>
        {triggeredBy && isTriggeredByAuthUser
          ? ``
          : `${triggeredBy?.first_name || ''}${
              triggeredBy?.last_name ? ` ${triggeredBy?.last_name || ''}` : ''
            }`}
      </div>
      <div className='md:flex-shrink-0 gap-1'>
        <EventAction authUser={auth?.user} path={path} />
      </div>
    </div>
  );
};

const Item = ({
  children,
  eventsCount,
  index,
  event,
}: {
  children: React.ReactNode;
  index: number;
  eventsCount: number;
  event: EventComplete;
}) => {
  return (
    <ActivityContext.Provider value={{ event, eventsCount, index }}>
      <div className={cn('relative pr-2')}>{children}</div>
    </ActivityContext.Provider>
  );
};

const TimeAgo = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'text-xs flex flex-col justify-end items-end gap-1 md:gap-0 !mt-[2.5px] text-foreground-secondary self-end md:self-auto',
        className,
      )}
    >
      {children}
    </div>
  );
};

const TriggeredInfo = ({
  event,
  path,
}: {
  event: EventComplete;
  path?: string;
}) => {
  return (
    <div className='flex flex-row items-start space-x-2 w-full md:w-5/6 h-fit'>
      <TriggeredByAvatar triggeredBy={event.triggered_by} />
      <div className='flex flex-col justify-center min-w-0 flex-1'>
        <Action
          triggeredBy={event.triggered_by}
          path={path}
          className={'min-h-7'}
        />
        <EventDetail />
      </div>
    </div>
  );
};

const Comment = ({ commentContent }: { commentContent: string }) => {
  return (
    <p className='italic text-foreground text-base_brand min-h-7 flex flex-col justify-center whitespace-pre-wrap [overflow-wrap:anywhere]'>
      {commentContent}
    </p>
  );
};

export const Activity = ({
  children,
  className,
  userType,
}: {
  children: React.ReactNode;
  className?: string;
  userType?: UserType;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col justify-end',
        userType === 'insurer' ? 'pb-36' : 'pb-10',
        className,
      )}
    >
      {children}
    </div>
  );
};

Activity.Item = Item;
Activity.Content = Content;
Activity.Marker = Marker;
Activity.Header = Header;
Activity.TriggeredByAvatar = TriggeredByAvatar;
Activity.Action = Action;
Activity.TimeAgo = TimeAgo;
Activity.Detail = EventDetail;
Activity.TriggeredInfo = TriggeredInfo;
Activity.Comment = Comment;
Activity.computeEventDiffs = computeEventDiffs;
